import { useDisclosure } from '@chakra-ui/react';
import React, { ReactNode, useCallback, useContext, useRef } from 'react';
import SuccessDialog from './SuccessDialog';

type ActionButton = string | VoidFunction;

export type OpenSuccessDialogProps = {
	title: string,
  description: string,
  actionButtonText: string,
	actionButton: ActionButton,
	closeButtonText: string
}

type SuccessDialogContextValue = {
	openSuccessDialog: (opts: OpenSuccessDialogProps) => void
}

interface SuccessDialogProviderProps {
	children?: ReactNode;
}

const SuccessDialogContext = React.createContext<SuccessDialogContextValue | undefined>(
	undefined,
);

export const useSuccessDialogContext = () => {
	const value = useContext(SuccessDialogContext);
	if (value === undefined) {
		throw Error('useSuccessDialogContext can not be used outside a SuccessDialogProvider');
	}
	return value;
};

export default function SuccessDialogProvider({ children }: SuccessDialogProviderProps) {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const openDialogOptions = useRef<OpenSuccessDialogProps | null>(null);

  const openSuccessDialog = useCallback((opts: OpenSuccessDialogProps) => {
		openDialogOptions.current = opts;
		onOpen();
	}, []);

	return (
		<SuccessDialogContext.Provider value={{ openSuccessDialog }}>
			<SuccessDialog { ...{...openDialogOptions.current, isOpen, onClose} }/>
			{children}
		</SuccessDialogContext.Provider>
	);
}
